import {createAction, createReducer} from 'redux-act';
import {ApplicationStoreType} from 'reducers';

export const USAGE = 'usage';
export const PRESCRIPTION = 'prescription';
export const PACKAGES = 'packages';

export type StepType = typeof USAGE | typeof PRESCRIPTION | typeof PACKAGES;

export const initialState: StepType = USAGE;

/**
 * List of actions
 */
export const changeStep = createAction<StepType>('WIZARD_SET_STEP');

/**
 * Step reducer
 */
export const wizardStep = createReducer<StepType>({}, initialState)
    /**
     * Subscribe actions
     * https://www.npmjs.com/package/redux-act#typescript
     */
    .on(changeStep, (state: StepType, payload: StepType): StepType => payload);

/**
 * Return current wizard step
 *
 * @param {ApplicationStoreType} store - redux store
 * @returns {StepType} wizard step
 */
export const getWizardStep = (store: ApplicationStoreType): StepType => store.wizardMs.wizardStep;
